import clsx from 'clsx'
import {useLayout} from '../../core'
import {AsideMenu} from './AsideMenu'
import React from "react";
import {Link} from 'react-router-dom'
import {UiIcon} from '../../../../components/UiIcon'
import {EducationLogo} from '../../../../components/EducationLogo'
import {DrawerComponent} from '../../../assets/ts/components'

const AsideDefault = () => {
  const {classes} = useLayout()
  const closeMenu = () => {
    DrawerComponent.getInstance('kt_aside')?.hide()
    document.getElementById('kt_aside_toggle')?.focus()
  }
  return (
    <div
      role='navigation'
      aria-label='Ana menü'
      id='kt_aside'
      className={clsx('aside', classes.aside.join(' '))}
      data-kt-drawer='true'
      data-kt-drawer-name='aside'
      data-kt-drawer-activate='{default: true, lg: false}'
      data-kt-drawer-overlay='true'
      data-kt-drawer-direction='start'
      data-kt-drawer-toggle='#kt_aside_toggle'
      onKeyDown={event => {
        if (event.key === 'Escape' && !event.defaultPrevented && DrawerComponent.getInstance('kt_aside')?.isShown()) {
          event.preventDefault()
          closeMenu()
        }
      }}
    >
      {/* begin::Brand */}
      <div className='aside-logo' id='kt_aside_logo'>
        <Link className='aside-brand' to='/dashboard' aria-label='Sınıf paneline dön' onClick={() => DrawerComponent.getInstance('kt_aside')?.hide()}>
          <EducationLogo placement='aside'/>
        </Link>
        <button type='button' className='aside-close' aria-label='Ana menüyü kapat' onClick={closeMenu}><UiIcon name='close' size={20}/></button>
      </div>
      {/* end::Brand */}

      {/* begin::Aside menu */}
      <div id='kt_aside_menu' className='aside-menu flex-column-fluid'>
        <AsideMenu asideMenuCSSClasses={classes.asideMenu} />
      </div>
      {/* end::Aside menu */}



    </div>
  )
}

export {AsideDefault}
